export const links = {
	home: () => '/',

	// Auth
	login: () => '/login',
	signup: () => '/signup',
	forgotPassword: () => '/forgot-password',
	resetPassword: (token?: string) => (token ? `/reset-password?token=${token}` : '/reset-password'),
	verifyEmail: (token?: string) => (token ? `/verify-email?token=${token}` : '/verify-email'),
	settingsSecurity: () => '/settings/security',
	verify2fa: () => '/verify-2fa',

	// Admin
	admin: () => '/admin',
	adminUsers: () => '/admin/users',
	adminFeatureFlags: () => '/admin/feature-flags',
	adminTranslations: () => '/admin/translations',
	adminSettings: () => '/admin/settings',
} as const;
